
import { getAccessToken } from "../../utils/authToken";

export const fetchGrowthHacks = async (growthhackpotentialclientid = "", fiscalYear = "FY 26", subSector = "", accountId = "", clientId = "", ghSubCategory = "", ghType = "", urgency = "", pageNumber = "", pageSize = "") => {
  try {
    const token = getAccessToken();
    const sessionId = sessionStorage.getItem("sessionId");
    const userId = sessionStorage.getItem("userId");
    
    console.log("fetchGrowthHacks called with fiscal year:", fiscalYear, "sub sector:", subSector, "account ID:", accountId, "client ID:", clientId, "GH sub-category:", ghSubCategory, "GH type:", ghType, "and urgency:", urgency);
    
    if (!token) {
      throw new Error("No access token found");
    }
    
    if (!sessionId) {
      throw new Error("No session ID found");
    }

    if (!userId) {
      throw new Error("No user ID found");
    }

    const getGrowthHacksEndpoint = process.env.REACT_APP_GET_GROWTH_HACKS;
    // const getGrowthHacksEndpoint = "https://gwcumobcpuwap02.azurewebsites.net/getgrowthhacks";
    
    const requestPayload = { 
      unique_id: sessionId,
      page_number: pageNumber.toString(),
      page_size: pageSize.toString(),
      growthhack_potential_client_id: growthhackpotentialclientid,
      fiscal_year: fiscalYear,
      sub_sector: subSector === "All" ? "" : subSector,
      account_id: accountId,
      client_id: clientId,
      growth_hack_type: ghType === "All" ? "" : ghType,
      growthHack_sub_category: ghSubCategory === "All" ? "" : ghSubCategory,
      urgency: urgency === "All" || urgency === "" ? "" : urgency,
      user_id: userId
    };
    
    console.log("fetchGrowthHacks API Payload:", JSON.stringify(requestPayload, null, 2));
    
    const response = await fetch(getGrowthHacksEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestPayload),
    });

    if (response.status === 200) {
      const data = await response.json();
      // return { success: true, data };
      return data;
    } else {
      console.warn("GetGrowthHacks API returned non-200 status:", response.status);
      // Import dummy data and return it
      const { growthHacksDummyData } = await import("./growthHacksDummyData.js");
      return { success: true, error: `API returned status ${response.status}`, data: growthHacksDummyData, message:"Server error" };
    }
  } catch (error) {
    console.error("Error calling GetGrowthHacks API:", error);
    // Import dummy data and return it
    const { growthHacksDummyData } = await import("./growthHacksDummyData.js");
    return { success: false, error: error.message, data: growthHacksDummyData };
  }
};


export const insertGrowthHack = async (growthHackData) => {
  try {
    const token = getAccessToken();
    const sessionId = sessionStorage.getItem("sessionId");
    
    if (!token) {
      throw new Error("No access token found");
    }
    
    if (!sessionId) {
      throw new Error("No session ID found");
    }

    const insertGrowthHacksEndpoint = process.env.REACT_APP_INSERT_GROWTH_HACKS;

    const requestBody = {
      unique_id: sessionId,
      growthhack_title: growthHackData.growthhack_title || "",
      growthhack_description: growthHackData.growthhack_description || "",
      client_id: growthHackData.client_id || "",
      revenue_potential: growthHackData.revenue_potential || "0",
      growthhack_type: growthHackData.growthhack_type || "",
      sector: growthHackData.sector || "",
      sub_sector: growthHackData.sub_sector || "",
      sub_sub_sector: growthHackData.sub_sub_sector || ""
    };

    const response = await fetch(insertGrowthHacksEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (response.status === 200) {
      const data = await response.json();
      return { success: true, data, message: 'Growth Hack added successfully' };
    } else {
      console.warn("InsertGrowthHacks API returned non-200 status:", response.status);
      return { success: false, error: `API returned status ${response.status}`, message:"Server error" };
    }
  } catch (error) {
    console.error("Error calling InsertGrowthHacks API:", error);
    return { success: false, error: error.message };
  }
};


export const updateGrowthHack = async (growthHackPotentialClientId, status, reasonForArchiving = "") => {
  try {
    const token = getAccessToken();
    const sessionId = sessionStorage.getItem("sessionId");
    
    if (!token) {
      throw new Error("No access token found");
    }
    
    if (!sessionId) {
      throw new Error("No session ID found");
    }

  const updateGrowthHackEndpoint = process.env.REACT_APP_UPDATE_GROWTH_HACKS;
  // const updateGrowthHackEndpoint = "https://gwcumobcpuwap02.azurewebsites.net/updategrowthhack";

    const requestBody = {
      unique_id: sessionId,
      growthhack_potential_client_id: growthHackPotentialClientId,
      status: status,
      reason_for_archiving: reasonForArchiving
    };
    console.log("Request body for updateGrowthHack:", requestBody);

    const response = await fetch(updateGrowthHackEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (response.status === 200) {
      const data = await response.json();
      return { success: true, data, message:"Growth Hack status Updated successfully" };
    } else {
      console.warn("UpdateGrowthHack API returned non-200 status:", response.status);
      return { success: false, error: `API returned status ${response.status}`, message:"Growth Hack Update failed" };
    }
  } catch (error) {
    console.error("Error calling UpdateGrowthHack API:", error);
    return { success: false, error: error.message };
  }
};


export const mapFormDataToApiPayload = (formData) => {
  return {
    growthhack_title: formData.title,
    growthhack_description: formData.description,
    client_id: formData.client,
    revenue_potential: formData.revenueValue || "0",
    growthhack_type: formData.category,
    sector: formData.sector || "",
    sub_sector: formData.subsector || "",
    sub_sub_sector: formData.subSubsector || ""
  };
};
  /**
   * Calls the getClients API to fetch clients by name prefix.
   */
  export const fetchClientsByPrefix = async (clientNamePrefixSearch = "", sector = "", subsector = "", showAll = "No") => {
    try {
      const token = getAccessToken();
      const sessionId = sessionStorage.getItem("sessionId");
      const userId = sessionStorage.getItem("userId");
    
      if (!token) {
        throw new Error("No access token found");
      }
    
      if (!sessionId) {
        throw new Error("No session ID found");
      }

      if (!userId) {
        throw new Error("No user ID found");
      }

      const getClientsEndpoint = process.env.REACT_APP_GET_CLIENTS;
      // const getClientsEndpoint = "https://gwcumobcpuwap02.azurewebsites.net/getclients";

      const requestBody = {
        unique_id: sessionId,
        client_name_prefix: clientNamePrefixSearch,
        sector: sector || "",
        sub_sector: subsector || "",
        user_id: userId,
        show_all: showAll
      };

      const response = await fetch(getClientsEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.status === 200) {
  const data = await response.json();
  // Optionally filter client list on frontend if backend ignores blanks
        return { success: true, data };
      } else {
        console.warn("GetClients API returned non-200 status:", response.status);
        return { success: false, error: `API returned status ${response.status}` };
      }
    } catch (error) {
      console.error("Error calling GetClients API:", error);
      return { success: false, error: error.message };
    }
  };


  export const fetchAccountsByPrefix = async (accountNamePrefixSearch = "") => {
    try {
      const token = getAccessToken();
      const sessionId = sessionStorage.getItem("sessionId");
      const userId = sessionStorage.getItem("userId");
    
      if (!token) {
        throw new Error("No access token found");
      }
    
      if (!sessionId) {
        throw new Error("No session ID found");
      }

      if (!userId) {
        throw new Error("No user ID found");
      }

      const getAccountsEndpoint = process.env.REACT_APP_GET_ACCOUNTS;
      // const getAccountsEndpoint = "https://gwcumobcpuwap02.azurewebsites.net/getaccounts";

      const requestBody = {
        unique_id: sessionId,
        account_name_prefix: accountNamePrefixSearch,
        user_id: userId
      };

      const response = await fetch(getAccountsEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.status === 200) {
        const data = await response.json();
        return { success: true, data };
      } else {
        console.warn("GetAccounts API returned non-200 status:", response.status);
        return { success: false, error: `API returned status ${response.status}` };
      }
    } catch (error) {
      console.error("Error calling GetAccounts API:", error);
      return { success: false, error: error.message };
    }
  };


  export const fetchCredentials = async (growthHackPotentialClientId) => {
    try {
      const token = getAccessToken();
      const sessionId = sessionStorage.getItem("sessionId");
      await fetchGrowthHackContacts(growthHackPotentialClientId);
      if (!token) {
        throw new Error("No access token found");
      }
    
      if (!sessionId) {
        throw new Error("No session ID found");
      }

      if (!growthHackPotentialClientId) {
        throw new Error("Growth hack potential client ID is required");
      }

      const getCredentialsEndpoint = process.env.REACT_APP_GET_CREDENTIALS;
      // const getCredentialsEndpoint = "https://gwcumobcpuwap02.azurewebsites.net/getcredentials";

      const requestBody = {
        unique_id: sessionId,
        growthhack_potential_client_id: growthHackPotentialClientId
      };

      const response = await fetch(getCredentialsEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.status === 200) {
        const data = await response.json();
        console.log("Fetched credentials API:", data);
        return { success: true, data };
      } else {
        console.warn("GetCredentials API returned non-200 status:", response.status);
        return { success: false, error: `API returned status ${response.status}` };
      }
    } catch (error) {
      console.error("Error calling GetCredentials API:", error);
      return { success: false, error: error.message };
    }
  };


  export const fetchGrowthHackContacts = async (growthHackPotentialClientId) => {
    try {
      const token = getAccessToken();
      const sessionId = sessionStorage.getItem("sessionId");

      if (!token) {
        throw new Error("No access token found");
      }

      if (!sessionId) {
        throw new Error("No session ID found");
      }

      if (!growthHackPotentialClientId) {
        throw new Error("Growth hack potential client ID is required");
      }

      const getGrowthHackContactsEndpoint = process.env.REACT_APP_GET_GROWTH_HACK_CONTACTS;
      //const getGrowthHackContactsEndpoint = "https://gwcumobcpuwap02.azurewebsites.net/getgrowthhackcontacts";

      const requestBody = {
        unique_id: sessionId,
        growthhack_potential_client_id: growthHackPotentialClientId,
      };

      const response = await fetch(getGrowthHackContactsEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.status === 200) {
        const data = await response.json();
        return { success: true, data };
      } else {
        console.warn("GetGrowthHackContacts API returned non-200 status:", response.status);
        return { success: false, error: `API returned status ${response.status}` };
      }
    } catch (error) {
      console.error("Error calling GetGrowthHackContacts API:", error);
      return { success: false, error: error.message };
    }
  };
